import { Link } from "react-router-dom"
import { useLanguage } from "../Contexte/LanguageContext";
import { useTraduction } from "../Contexte/TraductionContext";

function Footer() {
    const { language } = useLanguage()
    const { contentNav, contentUrl, contentBlog, contentFooter} = useTraduction()
    const articles = contentBlog.Articles || []
    const lastFiveArticles = articles.slice(-5);

    return (
        <footer className="container">
            <div className="FooterCoorLink">
                <div className="FooterCoor">
                    <Link to={"/" + language }>
                        <img loading="lazy" src={"../../../Assets/visuels/images/logo/renauRed.svg"} alt="Logo Renau" />
                    </Link>
                    <Link 
                        className="mt-32" to="https://www.google.com/maps/place/Carrer+de+l'Atletisme,+19,+08191+Rub%C3%AD,+Barcelona,+Spain/@41.5032536,2.0402907,16.06z/data=!4m6!3m5!1s0x12a493df6122dbf3:0x4b2e38c486ffa70!8m2!3d41.5033795!4d2.0435081!16s%2Fg%2F11c43v0t_1?hl=en-GB&entry=ttu" 
                        target="_blank">
                        C/ Atletismo, 19 - Polígono Industrial Can Rosés <br/>(08191) Rubí (Barcelona) España
                    </Link>
                   
                        <div id="InfoContact">
                            <ul>
                                <li className="mt-16">
                                    <p>{contentFooter.SousTitreCoordonnees1}</p>
                                    <Link to={"tel:" + contentFooter.ValTel1}>{contentFooter.TelCoordonnees1}</Link>
                                    <Link to={"mailto:" + contentFooter.ValMail1}>{contentFooter.MailCoordonnees1}</Link>
                                </li>
                                <li className="mt-16">
                                    <p>{contentFooter.SousTitreCoordonnees2}</p>
                                    <Link to={"tel:" + contentFooter.ValTel2}>{contentFooter.TelCoordonnees2}</Link>
                                    <Link to={"mailto:" + contentFooter.ValMail2}>{contentFooter.MailCoordonnees2}</Link>
                                </li>
                                <li className="mt-16">
                                    <p>{contentFooter.SousTitreCoordonnees3}</p>
                                    <Link to={"tel:" + contentFooter.ValTel3}>{contentFooter.TelCoordonnees3}</Link>
                                    <Link to={"mailto:" + contentFooter.ValMail3}>{contentFooter.MailCoordonnees3}</Link>
                                </li>
                                    
                            </ul>

                        </div>
                </div>
                <div className="FooterLink">
                    <ul>
                        <p><strong>{contentNav.TitreLien}</strong></p>
                        <li className="mt-4">
                            <Link to={ contentUrl.societe}>{contentNav.Societe}</Link>
                        </li>
                        <li>
                            <Link to={ contentUrl.Famille}>{contentNav.Convoyeur}</Link>
                        </li>
                        <li>
                            <Link to={ contentUrl.Blog}>{contentNav.Blog}</Link>
                        </li>
                        <li>
                            <Link to={ contentUrl.Contacter}>{contentNav.Contacter}</Link>
                        </li>
                        <li>
                            <Link to={ contentUrl.Devis}>{contentNav.Devis}</Link>
                        </li>
                    </ul>
                    <ul className="actualite">
                        <li>
                            <p>
                                <strong>
                                    {contentNav.TitreActualite}
                                </strong>
                            </p>
                        </li>
                        
                        {lastFiveArticles.map((item, index) => (
                            <li key={index} className="mt-4">
                                <Link to={ contentUrl.Blog + "/" + item.Lien}>{item.FooterTitle}</Link>
                            </li>
                        ))}
                        
                    </ul>
                    <ul>
                        <li>
                            <p>
                                <strong>
                                    {contentNav.TitreSuivre}
                                </strong>
                            </p>
                        </li>
                        
                        <li className="mt-4">
                            <Link to="https://www.linkedin.com/company/renau-transportadors-sl/">LinkedIn</Link>
                        </li>
                        <li>
                            <Link to="https://www.youtube.com/channel/UCQXsRtjvEXFQI3UXD4n7TKA">Youtube</Link>
                        </li>
                    </ul>
                </div>
            </div>
            <span className="mt-64"></span>
            <div className="CopyrightDroit">
                <p>{contentNav.Copyright}</p>
                <ul>
                    <li>
                        <Link to={ contentUrl.Confidentialite}>{contentNav.Politique}</Link>
                    </li>
                    <li>
                        <Link to={  contentUrl.Mentions}>{contentNav.Mentions}</Link>
                    </li>
                    <li>
                        <Link to={  contentUrl.Cookie}>{contentNav.Cookies}</Link>
                    </li>
                </ul>
            </div>
        </footer>  
    );
}

export default Footer;
